var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-structure-widget-overlay grey darken-4",style:(_vm.location?
    'height: 100%; top: 0px;'
    :
    'justify-content: space-around; align-items: center;')},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }